import React, { FC } from 'react';
import { Stack } from 'components/stack/stack';
import { FormTextInput } from 'components/form-inputs/form-text-input/form-text-input';
import { translate, translationKeys } from 'logic/translations/translations.service';
import { Field, FormErrors, InjectedFormProps, reduxForm } from 'redux-form';
import { useInProgress } from 'logic/store/tracker/tracker.hooks';
import { paymentSlice } from 'logic/store/payment';
import { isEmailValidator, isRequiredValidator } from 'logic/validators/validators';
import { clearEmptyFields } from 'logic/validators/utils';

export enum PayBySEPAContactFormFields {
  name = 'accountHolderName',
  email = 'email',
}

type SEPAContactFormValues = {
  [PayBySEPAContactFormFields.name]: string;
  [PayBySEPAContactFormFields.email]: string;
};

export type SEPAContactFormErrors = FormErrors<SEPAContactFormValues, any>;

const validateSEPAContactForm = ({ email, accountHolderName }: SEPAContactFormValues) => {
  const errors: SEPAContactFormErrors = {
    [PayBySEPAContactFormFields.name]: isRequiredValidator(accountHolderName),
    [PayBySEPAContactFormFields.email]: isEmailValidator(email),
  };

  return clearEmptyFields(errors);
};

export const SEPA_CONTACT_FORM_NAME = 'SEPA-contact-form-name';

const SEPAContact: FC<InjectedFormProps<SEPAContactFormValues>> = () => {
  const inProgress = useInProgress(paymentSlice.actions.setUpIbanSEPAPaymentMethod);

  return (
    <Stack gap={1}>
      <Field
        name={PayBySEPAContactFormFields.name}
        component={FormTextInput}
        placeholder={`${translate(translationKeys.fields.firstName)} ${translate(
          translationKeys.fields.lastName
        )}`}
        disabled={inProgress}
      />
      <Field
        name={PayBySEPAContactFormFields.email}
        component={FormTextInput}
        type={'emailAddress'}
        placeholder={translate(translationKeys.fields.emailPlaceholder)}
        disabled={inProgress}
      />
    </Stack>
  );
};

export const SEPAContactForm = reduxForm({
  form: SEPA_CONTACT_FORM_NAME,
  validate: validateSEPAContactForm,
})(SEPAContact);
